<template>
  <div class="d-flex flex-column px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-row>
      <b-col cols="12" class="mt-2">
        <PageTitle title="Tipos de clientes" />
      </b-col>
      <b-col cols="12" class="mt-4">
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=N1nxTPbaoVY&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=34', 
            title: 'Tipos de clientes' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a class="btn btn-success" href="https://api.construp.com.br/assets/Tipos de clientes.pdf" target="_blank" download>
          <i class="fas fa-file-pdf c-white"></i> Baixar Manual
        </a>
      </b-col>
    </b-row>
    
    <b-row class=" mt-5">
      <b-col cols="12" sm="6" class="mb-5 container">
        <label>
          Quais tipos de clientes podem se cadastrar no seu app? (Por padão
          todos vem ativos!)
        </label>
        <div class="d-flex align-items-center mt-4">
          <span class="mr-3 iconType"><i class="fas fa-user"></i></span>
          <b-form-checkbox
            :disabled="!whatClerkPermission()"
            class="mr-4"
            v-model="cliente"
          >
            Cliente (Pessoa Física)
          </b-form-checkbox>
        </div>
        <div class="d-flex align-items-center">
          <span class="mr-3 iconType"><i class="fas fa-tools fs-14"></i></span>
          <b-form-checkbox
            class="mr-4"
            v-model="profissional"
            :disabled="!whatClerkPermission()"
          >
            Profissional (Pessoa Física ou Jurídica)
          </b-form-checkbox>
        </div>
        <div class="d-flex align-items-center">
          <span class="mr-3 iconType"><i class="fas fa-building"></i></span>
          <b-form-checkbox
            :disabled="!whatClerkPermission()"
            class="mr-4"
            v-model="empresa"
          >
            Empresa (Pessoa Jurídica)
          </b-form-checkbox>
        </div>
        <div class="mt-4" v-if="whatClerkPermission()">
          <b-button
            variant="success"
            style="width: 150px"
            @click="$bvModal.show('modal-upd-cliente'), (msg = '')"
            >Atualizar</b-button
          >
        </div>
        <div class="mt-5">
          <h4>Campos obrigatórios no cadastro</h4>
        </div>
        <div class="mt-3 d-flex align-items-center">
          <span class="fs-18 mr-3">Telefone do cliente?</span>
          <b-form-checkbox 
            switch 
            @change="updateRequirePhone()" 
            v-model="selectPhone"
          ></b-form-checkbox>
        </div>
        <div class="mt-3 d-flex align-items-center">
          <span class="fs-18 mr-3">Serviço do profissional?</span>
          <b-form-checkbox 
            switch 
            @change="alterStatus()" 
            v-model="panelProfessional"
          ></b-form-checkbox>
        </div>
          <div v-if="panelProfessional" class="mt-3">
            <span>Minha área profissional</span><br>
            <router-link
              class="mt-2 btn btn-success"
              :to="{ name: 'panel-professional' }"
            >
              Acessar
            </router-link>
          </div>
        
      </b-col>
      <b-col cols="12" sm="6" class="container">
        <FakeAppNewUser
          class="prototypePhone marginTopFake"
          :titleDinamic="'Novo usuário'"
          :header-menu-color="fieldsColor.menuHeaderColor.hex8"
          :background-color="fieldsColor.backgroundColor.hex8"
          :icon-color="fieldsColor.iconColor.hex8"
          :font-color="fieldsColor.fontColor.hex8"
          :isClient="cliente"
          :isProfessional="profissional"
          :isShopkeeper="empresa"
          style="
            min-height: 700px;
            max-height: 700px;
            height: 700px;
            width: 50px;
          "
        />
      </b-col>
    </b-row>
    <b-modal id="modal-upd-cliente" hide-footer>
        <template #modal-title>Atualizar tipos de clientes</template>
        <div class="d-block text-center">
          <div class="alert alert-warning" role="alert">
            Caso seu aplicativo já esteja publicado, os cadastrados realizados
            anteriormente permanecerão ativos!
          </div>
        </div>

        <div class="d-block text-center mt-2" v-if="msg != ''">
          <div class="alert alert-danger" role="alert">
            {{ msg }}
          </div>
        </div>
        <b-row>
          <b-col cols="6">
            <b-button
              class="mt-3"
              variant="danger"
              block
              @click="$bvModal.hide('modal-upd-cliente')"
              >Cancelar</b-button
            >
          </b-col>
          <b-col cols="6">
            <b-button
              class="mt-3"
              variant="success"
              block
              @click="atualziarTipos()"
              >Atualizar</b-button
            >
          </b-col>
        </b-row>
      </b-modal>
      <VideoManual ref="videoManual"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';
import PageTitle from 'Components/PageTitle.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import FakeAppNewUser from '@/views/lojista/customizations/ChangeColor/FakeAppNewUser.vue';
import VideoManual from '@/components/VideoManual.vue';

export default {
  components: {
    PageTitle,
    FakeAppNewUser,
    VideoManual
  },
  mixins: [makeToast],
  data() {
    return {
      cliente: false,
      profissional: false,
      empresa: false,
      msg: '',
      selectPhone: false,
      panelProfessional: false,
      fieldsColor: {
        menuHeaderColor: {},
        backgroundColor: {},
        iconColor: {},
        fontColor: {},
      },
    };
  },

  computed: {
    ...mapState({
      dadosUsuario: (state) => state.dadosUsuario,
    }),
  },

  created() {
    this.buscarTipos();
    this.customization();
    this.getRequirePhone();
  },

  mounted() {
    this.getActiveProfission();
  },

  methods: {
    ...mapActions('shopkeeper', [
      'getCustomization',
      'isActiveProfission',
      'getCustom'
    ]),

    alterStatus() {
      const data = {
        is_active_professional: this.panelProfessional,
        construp_user_id: this.userTypeId()
    }

    this.$store.dispatch('startLoader');
    this.$store
        this.isActiveProfission(data)
        .then(() => {
          return this.makeToast('Sucesso', 'Dados atualizados com sucesso!', 'success');
        })
        .catch(() => {
            this.makeToast(
                'Erro',
                'Houve um erro ao ativar profissão, favor atualizar a página!',
                'danger'
            );
            })
        .finally(() => {
            this.$store.dispatch('endLoader');
        });
    },

    getActiveProfission() {
      this.$store.dispatch('startLoader');
      this.$store
          this.getCustom(this.userTypeId())
          .then((resp) => {
            this.panelProfessional = resp.data ? true: false;
          })
          .catch(() => {
              this.makeToast(
                  'Erro',
                  'Houve um erro ao ativar profissão, favor atualizar a página!',
                  'danger'
              );
              })
          .finally(() => {
              this.$store.dispatch('endLoader');
          });
    },

    updateRequirePhone(){
      const data = {
        construp_user_id: this.userTypeId(),
        field: "phone",
        required: this.selectPhone
      }
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/requirePhoneInRegister', data)
        .then((resp) => {
          if(resp.data.message === true) return this.makeToast('Sucesso', 'Dados atualizados com sucesso!', 'success');
        })
        .catch(()=>{
          this.makeToast('Erro', 'Houve um erro ao atualizar o dado', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    getRequirePhone(){
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/getRequireFields', this.userTypeId())
        .then((response) => {
          if(response.data.data.length && response.data.data.length > 0) {
            this.selectPhone = response.data.data[0].required === 1 ? true: false;
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    buscarTipos() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/clientesCadastro', this.userTypeId())
        .then((response) => {
          if (response.data.id) {
            this.cliente = response.data.cliente == 1 ? true : false;
            this.empresa = response.data.empresa == 1 ? true : false;
            this.profissional = response.data.profissional == 1 ? true : false;
          }
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    atualziarTipos() {
      this.msg = '';
      if (
        this.cliente == false &&
        this.profissional == false &&
        this.empresa == false
      ) {
        this.makeToast(
          'Opss',
          'Selecione pelo menos um tipo de cliente!',
          'danger'
        );
        this.msg = 'Selecione pelo menos um tipo de cliente!';
        return;
      }

      const data = {
        cliente: this.cliente,
        profissional: this.profissional,
        empresa: this.empresa,
        id_lojista: this.userTypeId(),
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('shopkeeper/updClientesCadastro', data)
        .then(() => {
          this.makeToast('Sucesso', 'Tipos de clientes atualizado!', 'success');
          this.$bvModal.hide('modal-upd-cliente');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.TIPO_CLIENTE
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return false;
        }
      }
      return true;
    },

    customization(){
      this.getCustomization(this.userTypeId())
        .then((response) => {
            if (!response.data.data) return;
            this.handleColors(response.data.data);
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
            this.loading = false;
          });
    },
    handleColors({ menuHeaderColor, backgroundColor, iconColor, fontColor }) {
      this.$set(this.fieldsColor.menuHeaderColor, 'hex8', menuHeaderColor);
      this.$set(this.fieldsColor.menuHeaderColor, 'hex', menuHeaderColor);

      this.$set(this.fieldsColor.backgroundColor, 'hex8', backgroundColor);
      this.$set(this.fieldsColor.backgroundColor, 'hex', backgroundColor);

      this.$set(this.fieldsColor.iconColor, 'hex8', iconColor);
      this.$set(this.fieldsColor.iconColor, 'hex', iconColor);

      this.$set(this.fieldsColor.fontColor, 'hex8', fontColor);
      this.$set(this.fieldsColor.fontColor, 'hex', fontColor);
    },
  },
};
</script>

<style scoped>
.iconType {
  font-size: 28px;
  color: #ff7f00;
}
</style>